import {
  IoBonfireOutline,
  IoCalendarNumberOutline,
  IoCameraOutline,
  IoChatbubblesOutline,
  IoGlobeSharp,
  IoListOutline,
  IoNewspaperOutline,
  IoPeopleOutline,
  IoPersonAddOutline,
  IoStarOutline,
  IoVideocamOutline,
} from "react-icons/io5";

export const MainPaths = [
  {
    name: "Dashboard",
    path: "/",
    icon: <IoGlobeSharp />,
  },
  {
    name: "Experiences",
    path: "/about/experiences",
    icon: <IoPeopleOutline />,
  },
  {
    name: "Events",
    path: "/events",
    icon: <IoCalendarNumberOutline />,
  },
  {
    name: "Images",
    path: "/gallery/photos",
    icon: <IoCameraOutline />,
  },
  {
    name: "Videos",
    path: "gallery/videos",
    icon: <IoVideocamOutline />,
  },
  {
    name: "Press",
    path: "/press",
    icon: <IoNewspaperOutline />,
  },

  {
    name: "Messages",
    path: "/messages",
    icon: <IoChatbubblesOutline />,
  },
];

export const SidebarPath = [
  {
    name: "Dashboard",
    path: "/",
    icon: <IoGlobeSharp />,
  },
  {
    name: "About",
    path: "/about",
    icon: <IoPersonAddOutline />,
  },
  {
    name: "Awards",
    path: "/about/awards",
    icon: <IoStarOutline />,
  },
  {
    name: "Experiences",
    path: "/about/experiences",
    icon: <IoBonfireOutline />,
  },
  {
    name: "Categories",
    path: "/categories",
    icon: <IoListOutline />,
  },
  {
    name: "Events",
    path: "/events",
    icon: <IoCalendarNumberOutline />,
  },
  {
    name: "Press",
    path: "/press",
    icon: <IoNewspaperOutline />,
  },
  {
    name: "Messages",
    path: "/messages",
    icon: <IoChatbubblesOutline />,
  },
];
